module.exports = __webpack_public_path__ + "img/blue_107.55d36fb5.png";